import { PaymentMethodCreditCard } from "@/api/opb/opbTypes";
import {
  Tag,
  TagVariant,
  TextButton,
  CardLogo,
} from "@industriousoffice/react-components";
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

export function CreditCardInfo({
  paymentMethod,
  withEdit,
  footer,
}: {
  paymentMethod: PaymentMethodCreditCard;
  withEdit?: boolean;
  footer?: ReactNode;
}) {
  const { t } = useTranslation("paymentMethods");
  const isExpired =
    paymentMethod.expYear < new Date().getFullYear() ||
    (paymentMethod.expYear === new Date().getFullYear() &&
      paymentMethod.expMonth < new Date().getMonth() + 1); // month in js starts at 0

  return (
    <>
      <div className="pt-1 grow-0">
        <CardLogo cardType={paymentMethod.cardType} />
      </div>
      <div className="pl-3 text-left grow shrink-0 relative w-24 flex-wrap">
        {paymentMethod.nickname && (
          <div className="pr-2 text-sm pb-1">
            {paymentMethod.nickname || null}
          </div>
        )}
        <div className="pr-2 font-bold md:block lg:flex wrap-break-word items-center">
          {t(paymentMethod.cardType)}
          <span className="font-normal">
            {paymentMethod.cardNumber.slice(-8, -4)}{" "}
            {paymentMethod.cardNumber.slice(-4)}
          </span>
          {paymentMethod.default && (
            <Tag
              text={t("Default")}
              variant={TagVariant.Info}
              className="mx-2 rounded-sm font-normal h-5"
            />
          )}
        </div>
        <div className={`pt-1 text-sm ${isExpired ? "text-red-500" : ""}`}>
          {isExpired ? t("Expired") : t("Expires")} {paymentMethod.expMonth}/
          {paymentMethod.expYear}
        </div>
        {withEdit ? (
          <TextButton
            type="button"
            className="absolute top-1 right-3"
            testId={`credit-card-edit_${paymentMethod.id}-btn`}
          >
            {t("Edit")}
          </TextButton>
        ) : null}
        {footer}
      </div>
    </>
  );
}
